export const LOGOUT_FALLBACK_REDIRECT_MS = 3000
